/*    
<summary>
  This functional component "ConfirmPopupHOC" provides props to the child component.
  1. State "showConfirmPopup" that manages the show/hide of pop up
  2. Function "confirmUnblockPopupToggleHandler" to toggle the show/hide popup state "showConfirmPopup"
  Developer:Aashish Singh, Created Date:04-Sept-2023
</summary>
<returns>Returns JSX</returns>
*/

import React, {useState } from 'react';

const ConfirmUnblockPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showConfirmUnblockPopup,setShowConfirmUnblockPopup] = useState<boolean>(false);

    const ConfirmUnblockToggleHandler = () => {
        setShowConfirmUnblockPopup(!showConfirmUnblockPopup);
    }
	
	return <Component showConfirmUnblockPopup={showConfirmUnblockPopup} confirmUnblockPopupToggleHandler={ConfirmUnblockToggleHandler} {...props}/>;
};

export default ConfirmUnblockPopupHOC;